import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Text, Translation } from '../../common';

const HISTORY_KEY = 'POSTBOX_HISTORY';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: 40,
    marginBottom: 28
  },
  line: {
    marginTop: 8,
    width: '100%',
    height: 1,
    background: theme.palette.grey['500']
  }
}));
const BodySeparator = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Text variant="body1Bold" color="grey500" align="center">
        <Translation inline>{HISTORY_KEY}</Translation>
      </Text>
      <Box className={classes.line} />
    </Box>
  );
};

export default BodySeparator;
